import {
  Breadcrumbs,
  ClickAwayListener,
  Grow,
  Link,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  Typography,
} from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import AlertError from "../../../../../common/components/alert_error";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { useContasReceberCadastroViewModel } from "../../viewModels/contas_receber_cadastro_view_model";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { CopiaContaReceberModal } from "../ContasReceber_lista/components/copia_conta_receber_modal";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownCliente } from "../../../../../common/components/dropdown_cliente";
import { DropDownSubconta } from "../../../../../common/components/dropdown_subconta";
import { DropDownUnidade } from "../../../../../common/components/dropdown_unidade";
import { RecebimentoParcial } from "./components/recebimentoParcial";
import { CadastroContaReceberParcialModal } from "../ContasReceber_lista/components/cadastro_recebimento_parcial_modal";
import { Link as LinkTo } from "react-router";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { DropDownBanco } from "../../../../../common/components/dropdown_banco";
import { DefaultFormMoneyInput } from "../../../../../common/components/default_form_money_input";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";

export const ContasReceberCadastro = () => {
  const viewModel = useContasReceberCadastroViewModel();

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row w-full justify-end gap-2">
              <BackButton onClick={() => viewModel.handlePageBack()} />
              {viewModel.contratoMultaJuros && (
                <PrimaryButton
                  onClick={() => viewModel.handleAplicarMultaJurosContrato()}
                  buttonColor="secondary-orange"
                  color="secondary"
                >
                  Aplicar Multa/Juros do Contrato Financeiro
                </PrimaryButton>
              )}

              <div>
                <Stack direction="row" spacing={2}>
                  <div className="w-[12rem]">
                    <PrimaryButton
                      ref={viewModel.menuRef}
                      id="composition-button"
                      aria-controls={
                        viewModel.openMenu ? "composition-menu" : undefined
                      }
                      aria-expanded={viewModel.openMenu ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={viewModel.handleToggleMenu}
                      buttonColor="primary-green"
                    >
                      Opções
                    </PrimaryButton>
                    <Popper
                      style={{ zIndex: 10000 }}
                      open={viewModel.openMenu}
                      anchorEl={viewModel.menuRef.current}
                      role={undefined}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom-start"
                                ? "left top"
                                : "left bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener
                              onClickAway={viewModel.handleCloseMenu}
                            >
                              <MenuList
                                autoFocusItem={viewModel.openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={viewModel.handleListKeyDown}
                              >
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleNewContaReceber()
                                  }
                                >
                                  Nova conta a receber
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleContaReceberCopiaOpenState(
                                      true,
                                    )
                                  }
                                >
                                  Copiar{" "}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    viewModel.handleContaReceberDeleteOpenState(
                                      viewModel.contaReceberSelectedId ?? null,
                                      true,
                                    )
                                  }
                                >
                                  Excluir{" "}
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form className="pb-8" onSubmit={viewModel.handleSalvarContaReceber}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Financeiro
            </Link>
            <Link underline="hover" color="inherit" component={"span"}>
              <LinkTo to="/ContasReceber_lista">Contas Receber Lista</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro Contas Receber
            </Typography>
          </Breadcrumbs>

          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                {" "}
                Contas Receber
              </h1>
              <RefreshButton onClick={() => { }} />
            </div>
          </div>
          <div className="flex gap-2 items-center w-full">
            {viewModel.contaReceber && (
              <div className="w-full mt-3 text-black dark:text-white p-4 rounded-xl bg-gray-100 dark:bg-gray-800 shadow-sm">
                <div className="text-lg">
                  <span className="font-semibold mr-2">
                    N° Conta a Receber:
                  </span>
                  <span className="font-bold">
                    {viewModel.contaReceber.nrContasReceber}
                  </span>
                </div>

                {/* <div className="text-lg ">
                                    <span className="font-semibold mr-2">Valor Mês:</span>
                                    <span className="font-bold">
                                        {viewModel.rateioGeralContaReceber.dataReceber
                                            ? new Date(viewModel.rateioGeralContaReceber.dataReceber).toLocaleDateString("pt-BR")
                                            : ""}
                                    </span>
                                </div> */}
              </div>
            )}
          </div>
          {"" === undefined ? (
            <div className="w-full">
              <AlertError messageErro={""} onTryAgain={() => { }} />
            </div>
          ) : (
            <></>
          )}
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer
              title="Contas Receber Status"
              arrangement="fullRow"
              border={false}
            >
              <div className="flex flex-col items-center w-full gap-4">
                <div className="flex justify-start mr-5 w-full">
                  <div className="mr-20">
                    <FormRadioGroupInput
                      name="status"
                      label="Status"
                      readOnly={viewModel.statusBloqueio}
                      onValueChange={(e) => {
                        const normalizado = isNaN(Number(e)) ? e : Number(e);
                        viewModel.handleStatusChange(normalizado as number);
                      }}
                      options={[
                        { id: 0, label: "Em Aberto" },
                        { id: 1, label: "Recebido" },
                        { id: 2, label: "Outros" },
                        { id: 3, label: "Atrasado" },
                        { id: 4, label: "Recebimento Parcial" },
                      ]}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  {viewModel.contaReceber?.status === 4 && (
                    <div className="flex w-[30%] flex-row justify-start pb-4">
                      <div className="flex w-60 flex-row items-end pb-4">
                        <PrimaryButton
                          type="button"
                          onClick={() =>
                            viewModel.handleContasReceberParcialCadastroOpenState(
                              true,
                            )
                          }
                          startIcon={
                            <DynamicIcon
                              nameIcon="CheckRounded"
                              size={25}
                              className="text-white"
                            />
                          }
                        >
                          Novo Recebimento Parcial
                        </PrimaryButton>
                      </div>
                    </div>
                  )}
                </div>
                {((viewModel.contaReceber &&
                  viewModel.contaReceber.status === 4) ||
                  (viewModel.contasReceberParcialLista?.length ?? 0) > 0) && (
                    <div className=" gap-4 w-full justify-start p-8">
                      <RecebimentoParcial
                        loading={viewModel.loading}
                        contasReceberParcialLista={
                          viewModel.contasReceberParcialLista ?? []
                        }
                        page={viewModel.pagination.page}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        statusRecebido={viewModel.contaReceber?.status ?? 0}
                        totalItems={viewModel.pagination.totalItems}
                        rowSelectionModel={viewModel.rowSelectionModel}
                        valorTotalParcial={viewModel.valorTotalParcial}
                        handleContasReceberParcialDeleteOpenState={
                          viewModel.handleContasReceberParcialDeleteOpenState
                        }
                        handlePageChange={viewModel.handlePageChange}
                        handleRowSelectionModelChange={
                          viewModel.handleRowSelectionModelChange
                        }
                        handleRowsPerPageChange={
                          viewModel.handleRowsPerPageChange
                        }
                        handleContasReceberParcialCadastroOpenState={
                          viewModel.handleContasReceberParcialCadastroOpenState
                        }
                      />
                    </div>
                  )}
                {viewModel.contaReceber &&
                  viewModel.contaReceber.status === 2 && (
                    <div className="grid grid-cols-2 gap-4 w-full justify-between bg-red-100 dark:bg-red-500 p-8">
                      <DefaultFormInput
                        name="outros"
                        label="Motivo"
                        multiline={true}
                        rows={5}
                        maxRows={10}
                        required={false}
                        readOnly={false}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  )}
                {viewModel.contaReceber &&
                  viewModel.contaReceber.status === 1 && (
                    <div className="grid grid-cols-2 gap-4 w-full justify-between bg-green-100 dark:bg-green-800  p-8">
                      <div className="gap-4 w-full justify-between">
                        <div className="w-[80%]  bg-white-100 pb-2">
                          <DropDownBanco
                            name="idBancoPagamento"
                            label="Banco"
                            required={false}
                            readOnly={viewModel.statusBloqueio}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>

                        <div className="w-[60%]">
                          <FormDatePickerInput
                            name="dataBaixa"
                            required={true}
                            label="Data Recebimento"
                            readOnly={viewModel.statusBloqueio}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </div>
                      <div className="gap-4 w-full justify-between">
                        <div className="w-full pb-2">
                          <DefaultFormInput
                            name="formaPagamento"
                            label="Forma Recebimento"
                            multiline={false}
                            required={false}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                        <div>
                          <DefaultFormMoneyInput
                            name="valorBaixa"
                            label="Valor Recebido"
                            required={true}
                            readOnly={viewModel.statusBloqueio}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </FormContainer>

            <FormContainer
              title="Informações"
              arrangement="fullRow"
              border={false}
            >
              <div className="flex flex-col items-center w-full gap-2 ">
                <div className="grid grid-cols-5 gap-4 w-full justify-between">
                  <DefaultFormMoneyInput
                    name="valorReceber"
                    label="Valor a Receber"
                    required={true}
                    readOnly={false}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DefaultFormMoneyInput
                    name="multa"
                    label="Multa"
                    required={false}
                    readOnly={false}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DefaultFormMoneyInput
                    name="juros"
                    label="Juros"
                    required={false}
                    readOnly={false}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DefaultFormMoneyInput
                    name="desconto"
                    label="Desconto"
                    required={false}
                    readOnly={false}
                    reactHookForm={viewModel.hookForm}
                  />
                  <div>
                    <DefaultFormMoneyInput
                      name="valorBaixa"
                      label="Valor Total"
                      required={true}
                      readOnly={true}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 w-full justify-between">
                  <DropDownCentroCusto
                    name="idCentroCusto"
                    label="Centro Custo"
                    required={true}
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownCliente
                    name="idCliente"
                    label="Cliente"
                    required={false}
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                    idCentroCusto={null}
                  />
                </div>
                <div className="grid grid-cols-2 gap-4 w-full justify-between">
                  <DropDownSubconta
                    name="idSubconta"
                    label="Subconta"
                    required={false}
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownUnidade
                    name="idClienteCentroCusto"
                    idCliente={viewModel.idClienteUnidade ?? null}
                    idCentroCusto={null}
                    label="Subconta"
                    required={false}
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="grid grid-cols-3 gap-4 w-full justify-between">
                  <div>
                    <DefaultFormInput
                      name="nome"
                      label="Titulo"
                      required={false}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                  <div>
                    <FormDatePickerInput
                      name="dataReceber"
                      label="Data a Receber"
                      required={true}
                      readOnly={false}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                  <div>
                    {/* DEVERA SER ALTERADA */}
                    <FormDatePickerInput
                      views={["year", "month"]}
                      tipoData="mes"
                      name="dataCompetencia"
                      label="Data da Competência."
                      required={false}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>

                <div className="w-full">
                  <DefaultFormInput
                    name="nrNotaFiscal"
                    label="N° Nota Fiscal"
                    multiline={true}
                    rows={3}
                    minRows={2}
                    maxRows={5}
                    required={false}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="gap-4 w-full">
                  <DefaultFormInput
                    name="nrDocumentos"
                    label="N° Documento"
                    multiline={true}
                    rows={3}
                    minRows={2}
                    maxRows={5}
                    required={false}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="w-full flex flex-row gap-3 ">
                  <div className="w-full">
                    <DefaultFormAutocomplete
                      name="idOrdemCompra"
                      required={false}
                      label="Ordem de Compra"
                      options={viewModel.ddlOrdemCompra ?? []}
                      getOptionLabel={(x) => x.title}
                      getOptionKey={(x) => x.id}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <div className="w-full">
                    <DropDownFuncionario
                      name="idFuncionario"
                      required={false}
                      readOnly={viewModel.saving}
                      label="Responsável"
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>
                <div className="grid grid-cols- gap-4 w-full">
                  <DefaultFormInput
                    name="observacao"
                    label="Observações"
                    multiline={true}
                    rows={5}
                    minRows={2}
                    maxRows={10}
                    required={false}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
              </div>
            </FormContainer>

            <FormContainer title="Anexo" arrangement="fullRow" border={false}>
              <>
                <div className="w-full pb-4 flex flex-row justify-between items-center gap-4">
                  <div className="w-[40%] justify-start ">
                    <div className="flex w-full">
                      <DefaultFormDownloadInput
                        name="arquivo1"
                        nameLimparFlag="limparArquivo1"
                        saving={viewModel.saving}
                        filename={viewModel.contaReceber?.nomeArquivo1 ?? null}
                        readOnly={viewModel.saving}
                        maxFilenameSize={70}
                        reactHookForm={viewModel.hookForm}
                        onDeleteFile={() =>
                          viewModel.handleArquivoDeleteOpenState(1)
                        }
                        onDownloadFile={(_) => {
                          if (
                            viewModel.contaReceber &&
                            viewModel.contaReceber.nomeArquivo1
                          ) {
                            viewModel.handleDownloadArquivo(
                              1,
                              viewModel.contaReceber.nomeArquivo1,
                            );
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="mt-2 gap-3 text-sm text-gray-600">
                    Tamanho total dos arquivos:{" "}
                    <span className="font-medium text-gray-800">
                      {(
                        ((viewModel.contaReceber?.tamanhoArquivo1 || 0) +
                          (viewModel.contaReceber?.tamanhoArquivo2 || 0) +
                          (viewModel.contaReceber?.tamanhoArquivo3 || 0)) /
                        (1024 * 1024)
                      ).toFixed(2)}{" "}
                      MB
                    </span>
                  </div>
                </div>

                <div className="w-full pb-4">
                  <div className="w-[40%] justify-start">
                    <div className="flex w-full">
                      <DefaultFormDownloadInput
                        name="arquivo2"
                        nameLimparFlag="limparArquivo2"
                        saving={viewModel.saving}
                        filename={viewModel.contaReceber?.nomeArquivo2 ?? null}
                        readOnly={viewModel.saving}
                        maxFilenameSize={70}
                        reactHookForm={viewModel.hookForm}
                        onDeleteFile={() =>
                          viewModel.handleArquivoDeleteOpenState(2)
                        }
                        onDownloadFile={(_) => {
                          if (
                            viewModel.contaReceber &&
                            viewModel.contaReceber.nomeArquivo2
                          ) {
                            viewModel.handleDownloadArquivo(
                              2,
                              viewModel.contaReceber.nomeArquivo2,
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="w-full pb-4">
                  <div className="w-[40%] justify-start">
                    <div className="flex w-full">
                      <DefaultFormDownloadInput
                        name="arquivo3"
                        nameLimparFlag="limparArquivo3"
                        saving={viewModel.saving}
                        filename={viewModel.contaReceber?.nomeArquivo3 ?? null}
                        readOnly={viewModel.saving}
                        maxFilenameSize={70}
                        reactHookForm={viewModel.hookForm}
                        onDeleteFile={() =>
                          viewModel.handleArquivoDeleteOpenState(3)
                        }
                        onDownloadFile={(_) => {
                          if (
                            viewModel.contaReceber &&
                            viewModel.contaReceber.nomeArquivo3
                          ) {
                            viewModel.handleDownloadArquivo(
                              3,
                              viewModel.contaReceber.nomeArquivo3,
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            </FormContainer>
          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4">
            <div>
              {viewModel.contaReceber && (
                <>
                  <div>
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={() =>
                        viewModel.handleOpenChangeHistory(
                          viewModel.contaReceber?.idContasReceber ?? null,
                          null,
                        )
                      }
                    >
                      <span className="text-xs">Historico de alterações</span>
                    </PrimaryButton>
                  </div>
                </>
              )}
            </div>

            <div className="flex flex-row gap-6 w-full justify-end">
              {viewModel.statusBloqueio && viewModel.contaReceber && (
                <div className="">
                  <PrimaryButton
                    onClick={() => viewModel.handleCancelarRecebimento()}
                    buttonColor="red"
                  >
                    Cancelar Recebimento
                  </PrimaryButton>
                </div>
              )}

              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={() => viewModel.handlePageBack()}
                >
                  Cancelar
                </h1>
              </div>

              <div className="w-40">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/* CONTAS RECEBER */}
      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleContaReceberDeleteOpenState(null, false)}
        title={`Você realmente deseja excluir esta Conta a Receber?`}
        onDelete={viewModel.handleConfirmarDeletarContaReceber}
      />

      {/* CONTAS RECEBER PARCIAL */}
      <DeleteDialog
        open={viewModel.openDeleteRecebimentoParcialModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleContasReceberParcialDeleteOpenState(null, false)
        }
        title={`Você realmente deseja excluir este recebimento parcial?`}
        onDelete={viewModel.handleConfirmarDeletarRecebimentoParcial}
      />

      <CadastroContaReceberParcialModal
        open={viewModel.painelRecebimentoParcialOpen}
        saving={viewModel.saving}
        contaReceberSelectedId={viewModel.contaReceberSelectedId}
        onSubmit={viewModel.handleCreateContasReceberParcial}
        ddlBanco={viewModel.ddlBanco ?? []}
        onClose={() =>
          viewModel.handleContasReceberParcialCadastroOpenState(false)
        }
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />

      <CopiaContaReceberModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        selectedIdContaReceber={viewModel.contaReceberSelectedId ?? 0}
        titulo={viewModel.tituloCopia ?? ""}
        onSubmit={viewModel.handleSubmitCopiaContaReceber}
        onClose={() => viewModel.handleContaReceberCopiaOpenState(false)}
      />
    </>
  );
};
